/* OSHA STORE — Account type guide navigation */
(function () {
  const TARGET_ID = 'account-types';

  function getAccountTypesSection(root) {
    if (root && root.matches && root.matches('.osha-account-types-band')) return root;
    return (root && root.querySelector && root.querySelector('.osha-account-types-band')) || document.querySelector('.osha-account-types-band');
  }

  function ensureHomeAnchor(root) {
    const section = getAccountTypesSection(root);
    if (!section) return;

    if (section.id !== TARGET_ID) section.id = TARGET_ID;

    if (window.location.hash === `#${TARGET_ID}` && section.dataset.oshaAnchorHandled !== 'true') {
      section.dataset.oshaAnchorHandled = 'true';
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(function () {
        section.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }, 80);
    }
  }

  function ensureProductGuideLink() {
    const productSection = document.querySelector('.product-information');
    if (!productSection) return;
    if (!productSection.querySelector('[data-osha-account-selector]')) return;
    if (productSection.querySelector('.osha-account-guide-wrap')) return;

    const grid = productSection.querySelector('.product-information__grid');
    if (!grid) return;

    const wrap = document.createElement('div');
    wrap.className = 'osha-account-guide-wrap';

    const link = document.createElement('a');
    link.className = 'osha-account-guide-link';
    link.href = `/#${TARGET_ID}`;
    link.setAttribute('dir', 'rtl');
    link.setAttribute('aria-label', 'إيه هو الفرق بين Full Account و Primary و Secondary؟');

    const text = document.createElement('span');
    text.textContent = 'إيه هو الفرق بين Full Account و Primary و Secondary؟';

    const arrow = document.createElement('b');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '↘';

    link.appendChild(text);
    link.appendChild(arrow);
    wrap.appendChild(link);
    grid.insertAdjacentElement('afterend', wrap);
  }

  function init(root) {
    ensureHomeAnchor(root || document);
    ensureProductGuideLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
